import { useState, useEffect, useRef } from "react";
import { Divider, Box, Button, CardMedia, IconButton } from "@mui/material";
import Detail from "../../main/detail/Detail";
import PageContents from "./PageContents";
import FirstPageContentRows from "./FirstPageContentRows";
import { rsActiveMenu, rsParentCom, rsProgress } from "../../RecoilStates";
import { useRecoilState } from "recoil";
import { UseFirstPageContent } from "./UseFirstPageContent";
import Header from "../../images/Content/Header1.png";
import Footer from "../../images/Content/Footer.png";
import EditIcon from "@mui/icons-material/Edit";
import VisibilityIcon from "@mui/icons-material/Visibility";
import RefreshIcon from "@mui/icons-material/Refresh";
import { useNavigate, useLocation } from "react-router-dom";
import { UseOffer } from "./HomeOffer/UseOffer";
import { readFromLS, writeToLS } from "../../util/LocalStrogeService";
import useBreakpoints from "../../hooks/useBreakpoints";

export default function FirstPageContent() {
  const navigate = useNavigate();
  const { UpdateOffersDataAll, UpdateOffersAll } = UseOffer();
  const [progress, setProgress] = useRecoilState(rsProgress);
  const [msActiveMenu, setMsActiveMenu] = useRecoilState(rsActiveMenu);
  const {
    GetComponents,
    SetComponents,
    removeComponent,
    ResetHeaderFooterCache,
  } = UseFirstPageContent();
  const [openDialog, setOpenDialog] = useState(false);
  const [components, setComponents] = useState();
  const [msParentCom, setMsParentCom] = useRecoilState(rsParentCom);
  const { isSmall } = useBreakpoints();
  const [showCombo, setShowCombo] = useState(true);
  const [homePageId, setHomePageid] = useState(
    readFromLS("homePage") ? readFromLS("homePage") : ""
  );

  useEffect(() => {
    setProgress(true);
    GetComponents(
      homePageId ? homePageId.id : 1,
      (components) => {
        // writeToLS("parentHome", "/homepagemanage");
        setComponents(components);
      },
      true
    );
  }, [homePageId]);

  const HomePageAutoComFunc = (homePage) => {
    setHomePageid(homePage);
    writeToLS("homePage", homePage);
  };

  return (
    <Detail
      breadChilds={{
        HomePageAutoCom: {
          show: showCombo,
          HomePageAutoComFunc: HomePageAutoComFunc,
        },
        normargin: true,
        title: "مدیریت محتوا",
        childs: [{ name: msActiveMenu.pageTitle, url: "/homepagemanage" }],
      }}
    >
      <Box sx={{ display: "flex", flexDirection: "column", height: "100%" }}>
        <Box
          sx={{
            flexGrow: 1,
            overflowY: "auto",
            backgroundColor: "#F5F5F5",
            height: "100%",
          }}
        >
          <Box sx={{ position: "relative" }}>
            <Box
              sx={{
                mb: 2,
                display: "flex",
                alignItems: "flex-end",
                position: "relative",
                width: isSmall ? "100%" : "60%",
                mx: "auto",
              }}
            >
              <CardMedia component="img" image={Header} />
              <Box
                sx={{
                  py: 1,
                  position: "absolute",
                  display: "flex",
                  justifyContent: "flex-end",
                  alignItems: "flex-end",
                  zIndex: 1000,
                  right: 5,
                }}
              >
                <IconButton
                  onClick={(evt) => {
                    setMsParentCom({
                      backUrl: "/homepagemanage",
                      parentComs: "/headerManage",
                    });
                    navigate("/headerManage");
                  }}
                  sx={{
                    p: 0.7,
                    mr: 1,
                    bgcolor: "secondary.main",
                    "&:hover": {
                      boxShadow: 3,
                      bgcolor: "secondary.main",
                    },
                  }}
                >
                  <EditIcon fontSize="small" sx={{ fill: "#fff" }} />
                </IconButton>
                <IconButton
                  onClick={(evt) => {
                    setProgress(true);
                    ResetHeaderFooterCache((csssc) => {
                      setProgress(false);
                    });
                  }}
                  sx={{
                    p: 0.7,
                    mr: 1,
                    bgcolor: "secondary.main",
                    "&:hover": {
                      boxShadow: 3,
                      bgcolor: "secondary.main",
                    },
                  }}
                >
                  <RefreshIcon fontSize="small" sx={{ fill: "#fff" }} />
                </IconButton>
              </Box>
            </Box>
          </Box>
          <FirstPageContentRows
            callback={(tempRow) => {
              SetComponents(tempRow, () => {
                GetComponents(
                  homePageId ? homePageId.id : 1,
                  (components) => {
                    setComponents(components);
                  },
                  true
                );
              });
            }}
            callbackRemove={(AID) => {
              removeComponent(AID, () => {
                GetComponents(
                  homePageId ? homePageId.id : 1,
                  (components) => {
                    setComponents(components);
                  },
                  true
                );
              });
            }}
            row={components}
            setRow={setComponents}
          />
          <Box sx={{ position: "relative" }}>
            <Box
              sx={{
                mb: 2,
                display: "flex",
                alignItems: "flex-end",
                position: "relative",
                width: isSmall ? "100%" : "60%",
                mx: "auto",
              }}
            >
              <CardMedia component="img" image={Footer} />
              <Box
                sx={{
                  py: 1,
                  position: "absolute",
                  display: "flex",
                  justifyContent: "flex-end",
                  alignItems: "flex-end",
                  zIndex: 1000,
                  right: 5,
                }}
              >
                <IconButton
                  onClick={(evt) => {
                    setMsParentCom({
                      backUrl: "/homepagemanage",
                      parentComs: "/footerManage",
                      homePageId: homePageId,
                    });
                    navigate("/footerManage");
                  }}
                  sx={{
                    p: 0.7,
                    mr: 1,
                    bgcolor: "secondary.main",
                    "&:hover": {
                      boxShadow: 3,
                      bgcolor: "secondary.main",
                    },
                  }}
                >
                  <EditIcon fontSize="small" sx={{ fill: "#fff" }} />
                </IconButton>
                <IconButton
                  onClick={(evt) => {
                    setProgress(true);
                    ResetHeaderFooterCache((csssc) => {
                      setProgress(false);
                    });
                  }}
                  sx={{
                    p: 0.7,
                    mr: 1,
                    bgcolor: "secondary.main",
                    "&:hover": {
                      boxShadow: 3,
                      bgcolor: "secondary.main",
                    },
                  }}
                >
                  <RefreshIcon fontSize="small" sx={{ fill: "#fff" }} />
                </IconButton>
              </Box>
            </Box>
          </Box>
        </Box>
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "flex-end",
          }}
        >
          <Divider />
          {isSmall ? (
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                gap: 2,
                p: 2,
              }}
            >
              <Box sx={{ display: "flex", justifyContent: "space-between" }}>
                <Button
                  sx={{ width: "100px" }}
                  variant="contained"
                  onClick={() => {
                    setOpenDialog(true);
                  }}
                >
                  آیتم جدید
                </Button>
                <Button
                  color="secondary"
                  sx={{ width: "100px" }}
                  variant="contained"
                  onClick={() => {
                    SetComponents(components, () => {
                      GetComponents(
                        homePageId ? homePageId.id : 1,
                        (components) => {
                          setComponents(components);
                        },
                        true
                      );
                    });
                  }}
                >
                  ثبت
                </Button>
              </Box>

              <Box sx={{ display: "flex", justifyContent: "space-between" }}>
                <Button
                  sx={{ width: "140px" }}
                  variant="contained"
                  onClick={() => {
                    setProgress(true);
                    UpdateOffersAll(() => setProgress(false));
                  }}
                >
                  به‌روزرسانی محصول
                </Button>
                <Button
                  sx={{ width: "140px" }}
                  variant="contained"
                  onClick={() => {
                    setProgress(true);
                    UpdateOffersDataAll(() => setProgress(false));
                  }}
                >
                  به‌روزرسانی داده
                </Button>
              </Box>
            </Box>
          ) : (
            <Box
              sx={{
                display: "flex",
                p: 2,
                justifyContent: "space-between",
              }}
            >
              <Button
                sx={{ width: "100px" }}
                variant="contained"
                onClick={() => {
                  setOpenDialog(true);
                }}
              >
                آیتم جدید
              </Button>
              <Box>
                <Button
                  sx={{ width: "140px" }}
                  variant="contained"
                  onClick={() => {
                    setProgress(true);
                    UpdateOffersAll(() => setProgress(false));
                  }}
                >
                  به‌روزرسانی محصول
                </Button>
                <Button
                  sx={{ width: "140px", mx: 2 }}
                  variant="contained"
                  onClick={() => {
                    setProgress(true);
                    UpdateOffersDataAll(() => setProgress(false));
                  }}
                >
                  به‌روزرسانی داده
                </Button>
                <Button
                  color="secondary"
                  sx={{ width: "100px" }}
                  variant="contained"
                  onClick={() => {
                    SetComponents(components, () => {
                      GetComponents(
                        homePageId ? homePageId.id : 1,
                        (components) => {
                          setComponents(components);
                        },
                        true
                      );
                    });
                  }}
                >
                  ثبت
                </Button>
              </Box>
            </Box>
          )}
        </Box>
      </Box>
      {openDialog && (
        <PageContents
          homePageId={homePageId}
          row={components}
          setRow={setComponents}
          openDialog={openDialog}
          setOpenDialog={setOpenDialog}
          components={components}
          callback={(tempRow) => {
            SetComponents(tempRow, () => {
              GetComponents(
                homePageId ? homePageId.id : 1,
                (components) => {
                  setComponents(components);
                },
                true
              );
            });
          }}
        />
      )}
    </Detail>
  );
}
